// extracted by mini-css-extract-plugin
module.exports = {"content":"ToSoZPDt","no-footer":"__1ontPiz_"};